<template>
  <div>
    <!-- Header -->
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h6 class="section-title mb-0">
        Add/Update Seat Quota Setting
      </h6>
      <router-link class="btn btn-primary btn-sm" to="seat-quota-management">
        Seat Quota Settings
      </router-link>
    </div>

    <div class="card p-3 shadow-sm">
      <div class="row mb-3">
        <div class="col-md-3 col-12">
          <label for="qs_name" class="form-label fw-bold small mb-1">
            Setting Name
          </label>
          <input
            id="qs_name"
            v-model="quota_settings.qs_name"
            v-b-tooltip.hover
            type="text"
            class="form-control slick-column"
            placeholder="Quota Name"
          />
        </div>
        <div class="col-md-3 col-12">
          <label for="qs_description" class="form-label fw-bold small mb-1">
            Description
          </label>
          <input
            id="qs_description"
            v-model="quota_settings.qs_description"
            v-b-tooltip.hover
            v-validate="'required'"
            type="text"
            class="form-control slick-column"
            placeholder="Quota Description"
          />
        </div>
        <div class="col-md-2 col-12">
          <label
            for="overall_quota_percentage"
            class="form-label fw-bold small mb-1"
          >
            Overall Quota %
          </label>
          <input
            id="overall_quota_percentage"
            v-model="quota_settings.overall_quota_percentage"
            v-b-tooltip.hover
            v-validate="'required'"
            type="text"
            class="form-control slick-column"
            placeholder="Overall Quota %"
          />
        </div>
        <div
          class="col-md-1 d-flex align-items-center justify-content-end mt-4"
        >
          <div class="d-flex align-items-center">
            <label class="mb-0 mr-2">{{ $t("active") }}</label>
            <b-form-checkbox
              v-model="quota_settings.qs_is_active"
              unchecked-value="N"
              value="Y"
              class="j-checkbox ml-3 custom-control custom-checkbox"
            >
            </b-form-checkbox>
          </div>
        </div>
      </div>

      <section>
        <div class="awq_sectionHead">Aggregator Wise Seat Quota</div>
      </section>

      <!-- Table of Contracts -->
      <table
        class="table table-bordered table-sm align-middle text-center no-padding-table w-50"
      >
        <thead class="table-light">
          <tr>
            <th style="width: 50%">Aggregator</th>
            <th style="width: 30%">Quota Percentage</th>
            <th style="width: 20%">Action</th>
          </tr>
        </thead>
        <tbody v-if="quota_settings.aggregatorWiseSettings.length">
          <tr
            v-for="(awq, awqIndex) in quota_settings.aggregatorWiseSettings"
            :key="awqIndex"
          >
            <td class="text-right p-0 slick-table-item">
              <multiselect
                v-model="awq.selectedUser"
                :options="filteredAggregatorUsers"
                :placeholder="'Select User'"
                @select="onSelectAggregator($event, awqIndex, 'select')"
                @remove="onSelectAggregator($event, awqIndex, 'remove')"
                label="agent_name"
                track-by="agent_id"
                class=""
              />
            </td>
            <td class="text-right p-0 slick-column">
              <input
                v-model="awq.quota_percentage"
                type="number"
                class="text-center"
                placeholder="Seat Quota (in %)"
              />
            </td>
            <td>
              <button
                class="btn-icon"
                @click.stop.prevent="removeAggregatorUserSettings(awqIndex)"
              >
                –
              </button>
            </td>
          </tr>
          <tr class="">
            <td colspan="4">
              <div
                class="row d-flex align-items-center justify-content-center border-top mt-4 mb-3 position-relative"
              >
                <button
                  @click.prevent.stop="addAggregatorUserSettings()"
                  class="btn-transparent add-more-button addBtn_multi"
                >
                  <img
                    src="@/assets/img/icons/plus.svg"
                    height="24"
                    width="24"
                  />
                </button>
              </div>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr class="">
            <td colspan="4">
              <div
                class="row d-flex align-items-center justify-content-center border-top mt-4 mb-3 position-relative"
              >
                <button
                  @click.prevent.stop="addAggregatorUserSettings()"
                  class="btn-transparent add-more-button addBtn_multi"
                >
                  <img
                    src="@/assets/img/icons/plus.svg"
                    height="24"
                    width="24"
                  />
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- Save Button -->
      <div class="text-center mt-3">
        <button
          :disabled="btenable"
          class="btn btn-primary btn-sm px-4"
          @click.prevent.stop="onFinalSubmit"
        >
          Save Settings
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import CinemaService from "@/services/CinemasService";

export default {
  data() {
    return {
      quota_settings: {
        quota_setting_id: null,
        qs_name: "",
        qs_description: "",
        overall_quota_percentage: "",
        is_default: "",
        qs_is_active: "Y",
        aggregatorWiseSettings: [
          {
            awq_id: null,
            quota_setting_id: null,
            quota_name: null,
            selectedUser: null,
            aggregator_user_id: null,
            quota_percentage: null,
            quota_is_active: "Y"
          }
        ]
      },
      aggregatorWiseSettingObj: {
        awq_id: null,
        quota_setting_id: null,
        quota_name: null,
        selectedUser: null,
        aggregator_user_id: null,
        quota_percentage: null,
        quota_is_active: "Y"
      },
      aggregator_users: [],
      submitted: false,
      btenable: false,
      quota_setting_id: null
    };
  },
  computed: {
    filteredAggregatorUsers() {
      let usersList = this.aggregator_users;
      usersList = this.aggregator_users.filter(
        x =>
          !this.quota_settings["aggregatorWiseSettings"].some(
            y => y.aggregator_user_id == x.agent_id
          )
      );

      return usersList;
    }
  },
  beforeMount() {
    this.GetThirdPartyUsers();
    const { quota_setting_id } = this.$route.params;

    if (quota_setting_id) {
      this.quota_setting_id = quota_setting_id;
      this.GetEditDetailsQuotaSettings(quota_setting_id);
    }
  },
  mounted() {},
  methods: {
    GetEditDetailsQuotaSettings(quota_setting_id) {
      let payload = {
        quota_setting_id: quota_setting_id
      };
      CinemaService.GetQuotaSettingById(payload)
        .then(response => {
          const { data } = response;
          if (data.status) {
            console.log("data", data);
            this.quota_settings = data.record;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(err => {
          console.log("Error:", err);
        });
    },
    onSelectAggregator(event, index, type) {
      console.log("event", event);
      console.log("index", index);
      console.log("type", type);

      if (type == "remove") {
        this.quota_settings["aggregatorWiseSettings"][index][
          "aggregator_user_id"
        ] = null;
      } else {
        this.quota_settings["aggregatorWiseSettings"][index][
          "aggregator_user_id"
        ] = event["agent_id"];
      }
    },
    GetThirdPartyUsers() {
      this.aggregator_users = [];
      CinemaService.GetThirdPartyUsers()
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.aggregator_users = data.Records.sort((a, b) => {
              if (!a.agent_name) return 1;
              if (!b.agent_name) return -1;
              return a.agent_name.localeCompare(b.agent_name);
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    addAggregatorUserSettings() {
      this.quota_settings["aggregatorWiseSettings"].push({
        awq_id: null,
        quota_setting_id: null,
        quota_name: null,
        selectedUser: null,
        aggregator_user_id: null,
        quota_percentage: null,
        quota_is_active: "Y"
      });
    },
    removeAggregatorUserSettings(index) {
      this.quota_settings["aggregatorWiseSettings"].splice(index, 1);
    },
    validateQuotaSettings(quota_settings) {
      const errors = [];

      if (!quota_settings.qs_name || quota_settings.qs_name.trim() === "") {
        errors.push("Quota setting name is required.");
      }

      if (
        quota_settings.overall_quota_percentage === "" ||
        quota_settings.overall_quota_percentage === null
      ) {
        errors.push("Overall quota percentage is required.");
      }

      const aggregatorList = quota_settings.aggregatorWiseSettings || [];

      if (!aggregatorList.length) {
        errors.push("At least one aggregator setting is required.");
      } else {
        aggregatorList.forEach((agg, index) => {
          const row = index + 1;

          if (!agg.aggregator_user_id) {
            errors.push(`Aggregator user is required in row ${row}.`);
          }

          if (
            agg.quota_percentage === "" ||
            agg.quota_percentage === null ||
            isNaN(agg.quota_percentage)
          ) {
            errors.push(`Valid quota percentage is required in row ${row}.`);
          }
        });
      }

      if (errors.length) {
        return { valid: false, errors };
      }

      return { valid: true, errors: [] };
    },

    onFinalSubmit() {
      const result = this.validateQuotaSettings(this.quota_settings);

      if (!result.valid) {
        this.$toasted.show(result.errors.join("\n"));
        return;
      }

      this.btenable = true;
      this.submitted = true;
      let loader = this.$loading.show();

      let payload = {
        ...this.quota_settings
      };

      let serviceApi = CinemaService.AddQuotaSettings(payload);
      if (!isNaN(String(this.quota_setting_id))) {
        serviceApi = CinemaService.UpdateQuotaSettings(payload);
      }

      serviceApi
        .then(response => {
          const { data } = response;
          if (data.status) {
            this.$router.replace({
              path: "/cinema-manager/seat-quota-management"
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(err => {
          console.log("Error:", err);
        })
        .finally(() => {
          loader.hide();
          this.btenable = false;
          this.submitted = false;
        });
    }
  }
};
</script>

<style>
.back {
  background-color: #fff;
}

.slick-table-item .multiselect__tags {
  border-radius: unset !important;
  border: unset !important;
}

.slick-table-item .multiselect__placeholder {
  color: #00000085 !important;
  font-weight: 400 !important;
  font-style: italic;
}

.slick-column .multiselect__tags {
  border-radius: unset !important;
  border: unset !important;
}

.slick-column input {
  border: none;
  height: 40px;
  margin: 0;
  width: 100%;
  padding-inline: 10px;
}

input.slick-column::placeholder,
.manual_bill_wrapper .multiselect__placeholder {
  font-size: 12px;
  font-style: italic;
}

/* Remove padding/margin from table cells */
.no-padding-table th,
.no-padding-table td {
  /* padding: 4px !important; */
  margin: 0 !important;
  vertical-align: middle !important;
}

.no-padding-table td {
  border: 1px solid #01070e;
}

.no-padding-table {
  zoom: 0.88;
}

/* Icon-only buttons (rounded border, no background) */
.btn-icon {
  width: 28px;
  height: 28px;
  /* border: 1px solid #01070e; */
  border-radius: 50%;
  background: none;
  font-size: 16px;
  line-height: 1;
  padding: 0;
  text-align: center;
  cursor: pointer;
}
.btn-icon:hover {
  border-color: #000;
}

.awq_sectionHead {
  color: var(--blue);
  font-weight: 500;
  font-style: italic;
  font-size: 15px;
  margin-bottom: 14px;
  margin-top: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/SeatQuotaManagement/AddEditSeatQuotas.vue